import { ref } from 'vue';

import { defineStore } from 'pinia';

export const useLoadingStore = defineStore('loading', () => {
	const isActive = ref(false);
	const message = ref('');
	const group = ref('');

	function show(options: { group?: string; message?: string }): void {
		isActive.value = true;
		message.value = options.message ?? '';
		group.value = options.group ?? 'module';
	}

	function hide(): void {
		isActive.value = false;
		message.value = '';
		group.value = '';
	}

	return {
		group,
		hide,
		isActive,
		message,
		show,
	};
});
